<template>
  <div class="advanced-menu-editor-item">
    <div class="background" @click="close" />

    <section v-if="o" class="wrapper no-scrollbar">
      <div style="text-align: right; margin-bottom: 8px">
        <span class="is-pulled-left is-pointer">
          <span v-if="o.hidden" class="tag is-dark" @click="toggleHidden">Hidden</span>
          <span v-else @click="toggleOutOfStock">
            <span v-if="o.out_of_stock" class="tag is-danger">{{
              $t("commerce.out-of-stock")
            }}</span>
            <span v-else class="tag is-primary">{{
              $t("commerce.available")
            }}</span>&nbsp;<toggle-button style="top: -1px" :sync="true" :value="!o.out_of_stock"
              :color="{ checked: '#00D1B2', unchecked: '#FF3860' }" :height="32" :width="50" @change="toggleOutOfStock" />
          </span>

          <!-- :labels="{ checked: 'Available', unchecked: 'Out of Stock' }" -->

          &nbsp;
          <span class="tag has-text-black" @click="gotoSimpleEditor">{{ $t("edit")
          }}<i class="fa fa-pencil-alt has-text-link fa-sm" style="margin-left: 6px" /></span>
        </span>
        <button class="delete is-large" @click="close" />
      </div>

      <div class="menu-item is-flex" :class="itemBackground">
        <div class="menu-pic">
          <i v-show="o.special" class="fa fa-star fa-sm has-text-info special" @click="toggleSpecial" />
          <figure v-if="o.pic || !o.color">
            <img v-webp="o.pic || placeholderPic" @error="defaultImg" :class="{ 'contain-img': o.contain_image }" />
          </figure>
          <figure v-else class="no-img" :style="'background-color: ' + o.color" />
        </div>
        <div class="has-text-left mr-4" style="flex: 1">
          <div class="name-description">
            <div class="is-flex">
              <p class="item-name">
                {{ o.name }}
              </p>
              <p style="flex-shrink: 1; margin-top: 4px">
                <span class="cat-tag has-text-link">
                  <span v-if="o.category">{{ categoryName(o.category) }}</span>
                  <span v-else class="has-text-black">Set Category</span>
                </span>
              </p>
            </div>
            <div class="item-description">
              <span v-if="o.description">{{ o.description }}</span>
              <span v-else style="font-weight: 500; opacity: 0.4">- no description -</span>
              <p v-if="o.by_weight" style="font-size: 0.85em; font-weight: 500">
                Price {{ o.by_weight }}, ~{{ o.estimated_weight }} grams per
                piece
              </p>
            </div>
          </div>
          <div style="margin-top: 4px">
            <span v-if="o.free_gift" class="tag is-danger has-text-weight-medium" style="margin-left: 4px"
              @click="removeFreeGift"><i class="fa fa-gift" />&nbsp;Free Gift over
              {{ currencySymbol(business.country) }}{{ o.free_gift }}</span>
            <span v-else>
              <span :class="{ discount: o.discount }">{{ currencySymbol(business.country) }}{{ o.price }}</span>
              <span v-if="o.discount" class="has-text-danger has-text-weight-medium" style="margin-left: 10px">{{
                currencySymbol(business.country)
              }}{{ discountedPrice(o) }}</span>
              <span v-if="o.by_weight" class="has-text-grey has-text-weight-medium">{{ translateByWeight(o.by_weight)
              }}</span>
            </span>
            <span class="is-pulled-right has-text-weight-medium">
              <span v-if="o.tags && o.tags.length" class="has-text-info" style="margin-right: 5px; font-size: 0.8em">
                {{ o.tags.join(", ") }}
              </span>
              <i v-show="o.options && o.options.length" class="fa fa-ellipsis-h has-text-black"
                style="font-size: 0.9em; margin-right: 5px" />
              <i v-show="o.schedule && o.schedule.length" class="fa fa-calendar-alt" style="font-size: 0.8em" />
            </span>
          </div>
        </div>
      </div>

      <div class="advanced">
        <div style="margin-bottom: 14px; margin-top: 4px">
          <span class="is-pointer special-btn" :class="{ 'selected-btn': o.special }" style="margin-right: 16px"
            @click="toggleSpecial">
            <i v-if="o.special" class="fa fa-star has-text-info" />
            <i v-else class="far fa-star has-text-grey" />
            {{ $t("special") }}
          </span>
          <span class="is-pointer special-btn" :class="{ 'selected-btn': o.flash_deal }" style="margin-right: 16px"
            @click="toggleFlashDeal">
            <i v-if="o.flash_deal" class="fa fa-bolt has-text-black" />
            <i v-else class="fa fa-bolt has-text-grey" />
            Flash Deal
          </span>
          <span class="is-pointer special-btn" :class="{ 'selected-btn': o.free_gift }" style="margin-right: 16px"
            @click="toggleFreeGift">
            <i v-if="o.free_gift" class="fa fa-gift has-text-black" />
            <i v-else class="fa fa-gift has-text-grey" />
            Free Gift
          </span>
          <!-- <span class="is-pointer special-btn" @click="toggleFlashDeal">
            <i class="fa fa-ellipsis-h" />
          </span> -->
        </div>

        <!-- <div v-if="!o.free_gift"> -->
        <div v-if="!parseInt(o.price)" class="field has-addons">
          <div class="control wleft">
            <a class="button is-light" @click="priceFromInfo"> Price From </a>
          </div>
          <div class="control is-expanded has-icons-left">
            <input class="input" type="number" v-model="o.price_from" :placeholder="'Starting Price'"
              @keydown="edited = true" />
            <span class="icon is-left">
              {{ currency }}
            </span>
          </div>
        </div>
        <div class="field has-addons">
          <div class="control wleft">
            <a class="button is-light" @click="discountInfo">
              <i class="fa fa-percent fa-sm" />&nbsp;Discount
            </a>
          </div>
          <div class="control is-expanded has-icons-right has-icons-left">
            <input class="input" type="number" v-model="o.discount"
              :placeholder="isPercentDiscount ? 'Percent' : 'Number'" @keydown="edited = true"
              @change="validateDiscount" />
            <span class="icon is-left has-text-link" style="pointer-events: initial" @click="toggleDiscountType">
              <i v-if="isPercentDiscount" class="fas fa-percentage link" />
              <i v-else class="fa fa-money-bill-alt link" />
            </span>
            <span class="icon is-small is-right has-text-grey" style="pointer-events: initial" @click="clearDiscount">
              <i class="far fa-trash-alt fa-sm" />
            </span>
          </div>
          <div class="control" @click="infoToast('Price after discount')">
            <a class="button is-disabled has-text-danger" style="width: 90px">{{ currencySymbol(business.country) }}{{
              discountedPrice(o) }}</a>
          </div>
        </div>
        <!-- </div> -->

        <!-- Category -->
        <div v-if="editCategory" class="choose-category">
          <a class="button is-white" style="padding: 6px" @click="editCategory = false">
            <i class="fa fa-chevron-left" />Edit Category
          </a>
          <span class="is-pulled-right">
            <span class="button has-text-success" @click="addCustomCategory"><i class="fa fa-plus fa-sm" />&nbsp;New
              Category</span>&nbsp;
            <span class="button has-text-danger" @click="setCategory(o, null)">
              <i class="far fa-trash-alt" />
            </span>
          </span>
          <p class="hint">A menu item can have 1 category</p>
          <div class="buttons" style="margin-top: 6px">
            <a v-for="c in categories" :key="c.name" class="button is-rounded"
              :class="{ 'is-link': o.category === c.name }" @click="setCategory(o, c.name)">{{ c[contentLang] || c.name
              }}</a>
            <span v-show="!categories.length" class="button has-text-grey" @click="addNewCategory">No Categories Set
              Up</span>
          </div>
        </div>
        <div v-else class="field has-addons">
          <div class="control wleft">
            <a class="button is-light" @click="openCategories">
              <i class="fa fa-list-ul fa-sm" />&nbsp;Category
            </a>
          </div>
          <div class="control is-expanded">
            <a class="button is-disabled is-fullwidth" @click="openCategories">
              <span v-if="o.category" class="has-text-info">
                {{ categoryName(o.category) }}
              </span>
              <span v-else class="click-set">{{ $t("click-to-set") }}</span>
            </a>
          </div>
        </div>

        <!-- Tags -->
        <div v-if="editTags" class="choose-category">
          <a class="button is-white" style="padding: 6px" @click="editTags = false">
            <i class="fa fa-chevron-left" />Edit Tags
          </a>
          <a class="button has-text-success is-pulled-right" @click="createTag"><i class="fa fa-plus" />&nbsp;New Tag</a>
          <p class="hint">A menu item can have multiple tags</p>
          <div class="buttons" style="margin-top: 6px">
            <a v-if="!allTags.length" class="button is-light" @click="createTag">No Tags Yet</a>
            <a v-for="t in allTags" :key="t" class="button is-rounded is-capitalized" :class="{ 'is-link': isTag(o, t) }"
              @click="setTag(o, t)">{{ t }}</a>
          </div>
          <!-- <div class="buttons" style="margin-top: 6px">
            <span @click="showExampleTags = !showExampleTags">
              <a v-if="showExampleTags" class="button is-white">
                <i class="fa fa-chevron-up" />&nbsp;Hide Example Tags
              </a>
              <a v-else class="button is-white"
                ><i class="fa fa-chevron-down" />&nbsp;Show Example Tags
              </a>
            </span>
            <span v-if="showExampleTags">
              <a
                v-for="t in defaultTags"
                :key="t"
                class="button is-rounded is-capitalized"
                :class="{ 'is-link': isTag(o, t) }"
                @click="setTag(o, t)"
                >{{ t }}</a
              >
            </span>
          </div> -->
          <div style="margin-top: 6px">
            <p>
              <span @click="showExampleTags = !showExampleTags">
                <a class="button is-white">
                  <i v-if="showExampleTags" class="fa fa-chevron-up" />
                  <i v-else class="fa fa-chevron-down" />
                  &nbsp;Example Tags
                </a>
              </span>
            </p>
            <div v-if="showExampleTags">
              <p v-for="t in defaultTags" :key="t" style="padding: 4px">
                <span class="button is-small is-rounded is-capitalized" :class="{ 'is-link': isTag(o, t) }"
                  @click="setTag(o, t)">
                  {{ t }}</span>
              </p>
            </div>
          </div>
        </div>
        <div v-else class="field has-addons">
          <div class="control wleft">
            <a class="button is-light" @click="openTags">
              <i class="fa fa-tags fa-sm" />&nbsp;Tags
              <span style="width: 25px" />
            </a>
          </div>
          <div class="control is-expanded">
            <a class="button is-disabled is-fullwidth" @click="openTags">
              <span v-if="o.tags && o.tags.length" class="has-text-info is-capitalized">
                {{ o.tags.join(", ") }}
              </span>
              <span v-else class="click-set">{{ $t("click-to-set") }}</span>
            </a>
          </div>
        </div>

        <!-- Options -->
        <div v-if="editOptions" class="choose-category">
          <div>
            <a class="button is-white" style="padding: 6px" @click="editOptions = false">
              <i class="fa fa-chevron-left" />Edit Options
            </a>
            <a class="button has-text-success is-pulled-right" @click="newOptionsMenu">
              <i class="fa fa-plus fa-sm" />&nbsp;New Options
            </a>
          </div>
          <p class="hint">A menu item can have multiple options</p>
          <div class="buttons" style="margin-top: 6px">
            <a v-for="m in publicOptionsMenus" :key="m.id" class="button is-rounded is-capitalized"
              :class="{ 'is-link': isOptions(o, m) }" @click="setOptions(o, m)">
              {{ optionsName(m.data) }}
              <span v-if="optionRank(o, m)" class="option-rank">#{{ optionRank(o, m) }}</span>
            </a>
          </div>
          <div v-if="privateOptionsMenus.length">
            <p class="hint">Private Options</p>
            <div class="buttons" style="margin-top: 6px">
              <a v-for="m in privateOptionsMenus" :key="m.id" class="button is-rounded is-capitalized"
                :class="{ 'is-link': isOptions(o, m) }" @click="setOptions(o, m)">{{ optionsName(m.data) }}</a>
            </div>
          </div>
        </div>
        <div v-else class="field has-addons">
          <div class="control wleft">
            <a class="button is-light" @click="openOptions">
              <i class="fa fa-ellipsis-h fa-sm" />&nbsp;Options
            </a>
          </div>
          <div class="control is-expanded">
            <a class="button is-disabled is-fullwidth" @click="openOptions">
              <span v-if="o.options && o.options.length" class="has-text-info">
                {{ optionsList(o.options) }}
              </span>
              <span v-else class="click-set">{{ $t("click-to-set") }}</span>
            </a>
          </div>
        </div>

        <div v-if="showMoreSettings">
          <!-- Schedule -->
          <div v-if="editSchedule" class="choose-category">
            <a class="button is-white" style="padding: 6px" @click="editSchedule = false">
              <i class="fa fa-chevron-left" />Edit Schedule
            </a>

            <a class="button is-pulled-right" style="padding: 12px" :class="{ 'is-success': !o.schedule }"
              @click="clearSchedule">
              All Days
            </a>
            <div class="buttons" style="margin-top: 6px">
              <a v-for="d in days" :key="d" class="button is-rounded is-capitalized"
                :class="{ 'is-link': isScheduleDay(o, d) }" @click="setSchedule(o, d)">{{ d }}</a>
            </div>
          </div>
          <div v-else class="field has-addons">
            <div class="control wleft">
              <a class="button is-light" @click="openSchedule">
                <i class="far fa-calendar-alt fa-sm" />&nbsp;Schedule
              </a>
            </div>
            <div class="control is-expanded">
              <a class="button is-disabled is-fullwidth" @click="openSchedule">
                <span v-if="o.schedule && o.schedule.length" class="has-text-info is-capitalized">
                  {{ o.schedule.join(", ") }}
                </span>
                <span v-else class="click-set">{{ $t("click-to-set") }}</span>
              </a>
            </div>
          </div>

          <div class="field has-addons" @click="setMaxCount">
            <div class="control wleft">
              <a class="button is-light">
                <i class="fa fa-sort-numeric-down fa-sm" />&nbsp;Max Count
              </a>
            </div>
            <div class="control is-expanded">
              <a class="button is-disabled is-fullwidth">
                <span v-if="o.max_count" class="has-text-info is-capitalized">
                  {{ o.max_count }}
                </span>
                <span v-else class="click-set">{{ $t("click-to-set") }}</span>
              </a>
            </div>
          </div>

          <div class="field has-addons" @click="setPrepTime">
            <div class="control wleft">
              <a class="button is-light">
                <i class="fa fa-stopwatch fa-sm" />&nbsp;Prep Time
              </a>
            </div>
            <div class="control is-expanded">
              <a class="button is-disabled is-fullwidth">
                <span v-if="o.prep_time" class="has-text-info is-capitalized">
                  {{ o.prep_time }} minutes
                </span>
                <span v-else class="click-set">{{ $t("click-to-set") }}</span>
              </a>
            </div>
          </div>

          <div v-if="editByWeight" class="choose-category">
            <a class="button is-white" style="padding: 6px" @click="editByWeight = false">
              <i class="fa fa-chevron-left" />Edit By Weight
            </a>

            <a class="button is-pulled-right" style="padding: 12px" :class="{ 'is-success': !o.by_weight }"
              @click="setByWeight(o, null)">
              Not By Weight
            </a>
            <div class="field has-addons" style="margin-top: 10px">
              <div class="control">
                <a class="button is-light" @click="discountInfo">
                  <i class="fa fa-weight fa-sm" />&nbsp;Est weight per piece
                  (grams)
                </a>
              </div>
              <div class="control is-expanded">
                <input class="input" type="number" v-model="o.estimated_weight" placeholder="Grams"
                  @keydown="edited = true" />
              </div>
            </div>
            <div class="buttons" style="margin-top: 6px">
              <a v-for="w in weights" :key="w" class="button is-rounded is-capitalized"
                :class="{ 'is-link': isByWeight(o, w) }" @click="setByWeight(o, w)">{{ w }}</a>
            </div>
          </div>
          <div v-else class="field has-addons" @click="openByWeight">
            <div class="control wleft">
              <a class="button is-light">
                <i class="fa fa-weight fa-sm" />&nbsp;By Weight
              </a>
            </div>
            <div class="control is-expanded">
              <a class="button is-disabled is-fullwidth">
                <span v-if="o.by_weight" class="has-text-info is-capitalized">
                  Price {{ o.by_weight }}
                  <span class="tag is-info">~{{ o.estimated_weight }} grams/piece</span>
                </span>
                <span v-else class="click-set">{{ $t("click-to-set") }}</span>
              </a>
            </div>
          </div>

          <div>
            <span v-if="vat" class="is-pointer is-pulled-left" @click="toggleVatable">
              <toggle-button style="top: -1px; margin-right: 6px" :sync="true" :value="o.vatable"
                :color="{ checked: '#555', unchecked: '#bbb' }" :height="22" :width="40" @change="toggleVatable" />
              <span v-if="o.vatable">Vatable</span>
              <span v-else class="has-text-grey">Not Vatable</span>
            </span>

            <div class="has-text-right" @click="toggleHidden">
              <span style="vertical-align: bottom; margin-right: 6px">
                <span v-if="o.hidden" class="has-text-grey">Hidden</span>
                <span v-else>Visible</span>
              </span>
              <toggle-button style="top: -1px" :sync="true" :value="!o.hidden"
                :color="{ checked: '#cdd', unchecked: '#666' }" :height="22" :width="40" @change="toggleHidden" />
            </div>
          </div>
        </div>
        <div class="has-text-centered" style="margin: 20px">
          <span class="button is-light" @click="showMoreSettings = !showMoreSettings">
            <i v-if="showMoreSettings" class="fa fa-chevron-up" />
            <i v-else class="fa fa-chevron-down" />
            &nbsp;More Settings
          </span>
        </div>
      </div>
      <div class="bottom-btns">
        <span class="button" style="padding: 6px" @click="stopEditItem">Close Item&nbsp;<i
            class="fa fa-chevron-down" /></span>
        <span class="button is-pulled-right" style="padding: 6px" @click="nextItem">Next Item&nbsp;<i
            class="fa fa-chevron-right" /></span>
      </div>
    </section>
  </div>
</template>


<script>
// import MenuEditorSkeleton from "@/components/MenuEditorSkeleton";

export default {
  name: "AdvancedMenuEditorItem",
  components: {},
  props: {
    selectedItem: Object,
    business: Object,
    customTags: Array,
    optionsMenus: Array,
    categories: Array,
    vat: Number,
    freeGiftItem: Object,
  },
  data() {
    return {
      o: null, // deep copy of selectedItem
      showMoreSettings: false,
      showExampleTags: true,
      showOptions: false,
      showCategories: false,
      showTags: false,
      menu: null, // set from blob
      edited: false,
      placeholderPic: this.$store.state.menuItemPlaceholderPic,
      editCategory: false,
      editOptions: false,
      editTags: false,
      editSchedule: false,
      editByWeight: false,
      menuCategories: null, // set from blob
      //   categories: [], // set from blob if exists
      editingCategory: null, // selected category to edit
      addingNewCategory: false,
      contentLang: "en", // default English
      days: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"], // for schedule
      weights: ["per gram", "per 100 grams", "per kg"],
      defaultTags: [
        // "dine-in",
        "breakfast",
        "lunch",
        "dinner",
        "vegan",
        "member", // only for members
        "dine-in-only", // only for dine-in
        "*9-12", // breakfast hours
      ], // "t12-14,17-24" thai alcohol hours
      newTags: [], // not necessarily attached to any objects yet, ephemeral
    };
  },
  computed: {
    currency() {
      return this.currencySymbol(this.business.country);
    },
    allTags() {
      // var tags = this.defaultTags.concat(this.customTags);
      var tags = this.customTags;
      return tags.concat(this.newTags);
    },
    superuser() {
      return this.$store.getters.isSuperUser;
    },
    itemBackground() {
      if (this.o.hidden) return "bg-hidden";
      if (this.o.out_of_stock) return "bg-pink";
      if (this.o.flash_deal) return "border-yellow"; //"bg-yellow";
      return null;
    },
    isPercentDiscount() {
      if (this.o.discount_type === "number") return false;
      return true;
    },
    publicOptionsMenus() {
      return this.optionsMenus.filter((m) => !m.data.parent_item_id);
    },
    privateOptionsMenus() {
      return this.optionsMenus.filter(
        (m) => m.data.parent_item_id === this.selectedItem.id
      );
    },
  },
  mounted() {
    this.setObject();
  },
  activated() { },
  methods: {
    close() {
      if (this.edited) {
        this.prefillActualWeight();
        this.$emit("save", this.o);
      }
      this.$emit("close");
    },
    prefillActualWeight() {
      if (this.o.estimated_weight) {
        this.o.actual_weight = this.o.estimated_weight;
      } else {
        delete this.o.estimated_weight;
        delete this.o.actual_weight;
      }
    },
    update() {
      this.edited = true;
      this.o = JSON.parse(JSON.stringify(this.o));
    },
    gotoSimpleEditor() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px;'>
        <i class='fa fa-arrow-right'></i>&nbsp;Simple Menu Editor</p>
        <p><i>This will save any edits you made to your menu before leaving this page.</i></p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `Save and Go <i class='fa fa-chevron-right'></i>`,
      }).then((val) => {
        if (!val.value) return;
        this.goto("/commerce_page/menu-product-list");
      });
    },
    setObject() {
      this.o = this.deepCopy(this.selectedItem);
      this.showExampleTags = this.customTags.length ? false : true;
    },
    openCategories() {
      this.resetEdit(); // closes anything else that might be open
      this.editCategory = true;
    },
    openTags() {
      this.resetEdit(); // closes anything else that might be open
      this.editTags = true;
    },
    openOptions() {
      this.resetEdit();
      this.editOptions = true;
    },
    openSchedule() {
      this.resetEdit();
      this.editSchedule = true;
    },
    openByWeight() {
      this.resetEdit();
      this.editByWeight = true;
    },
    setMaxCount() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px'><i class='fa fa-sort-numeric-down'></i>&nbsp;Set Max Count</p>
        <p>The maximum number of units of this item a customer can add to their order.</p>
        </div>`,
        input: "number",
        inputPlaceholder: 1,
        inputValue: this.o.max_count,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Set",
        cancelButtonText: "Clear (Any Count)",
        cancelButtonColor: this.bulmaColor("danger"),
        inputValidator: (val) => {
          var count = parseInt(val);
          if (!count) return "Enter a number > 0";
        },
      }).then((val) => {
        if (val.dismiss === "close" || val.dismiss === "backdrop") {
          return;
        }
        let count = null; // val.dismiss === 'cancel' means 0 / any
        if (val.value) count = parseInt(val.value);
        this.o.max_count = count;
        this.update();
      });
    },
    setPrepTime() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px'><i class='fa fa-stopwatch'></i>&nbsp;Set Prep Time</p>
        <p style='margin-bottom:10px'>How long does it take to prepare this item (in minutes)?</p>
        <p>If 20 minutes or less leave blank.</p>
        </div>`,
        input: "number",
        inputPlaceholder: "30 minutes",
        inputValue: this.o.max_count,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Set",
        cancelButtonText: "Clear (20 mins or less)",
        cancelButtonColor: this.bulmaColor("danger"),
        inputValidator: (val) => {
          var minutes = parseInt(val);
          if (!minutes) return "Enter a number";
        },
      }).then((val) => {
        if (val.dismiss === "close" || val.dismiss === "backdrop") {
          return;
        }
        let minutes = null; // val.dismiss === 'cancel' means 0 / any
        if (val.value) minutes = parseInt(val.value);
        this.o.prep_time = minutes;
        this.update();
      });
    },
    discountInfo() {
      var msg = "Enter a discount for item<br>as either a percent or number";
      this.infoToast(msg, "top", 6000);
    },
    priceFromInfo() {
      var msg = "Will show as: <b>From $100</b>";
      this.infoToast(msg, "top", 6000);
    },
    createTag() {
      this.$swal({
        html: `<div style='text-align:left'>
  <p style='font-size:1.2em; margin-bottom:12px;'>
  <i class='fa fa-tag'></i>&nbsp;Create New Tag
  </p>
  <p>Multiple tags can be assigned to each menu item.</p>
  </div>`,
        input: "text",
        showCloseButton: true,
        showCancelButton: true,
        inputValidator: (val) => {
          if (!val) return "Enter something";
        },
      }).then((val) => {
        if (!val.value) return;
        this.newTags.push(val.value);
        this.setTag(this.o, val.value);
      });
    },
    toggleDiscountType() {
      var o = this.o;
      this.clearDiscount(o);
      if (o.discount_type === "number") o.discount_type = "percent";
      else o.discount_type = "number";
      this.infoToast(`Discount type: ${o.discount_type}`);
      this.update();
    },
    toggleHidden() {
      if (this.o.out_of_stock) this.o.out_of_stock = false;
      this.o.hidden = !this.o.hidden;
      this.update();
    },
    toggleFlashDeal() {
      var o = this.o;
      o.flash_deal = !o.flash_deal;
      if (o.flash_deal) {
        this.notifySuperusersAboutFlashDeal(o);
        // this.infoToast("TUK will contact you about promoting your flash deal");
      }
      this.update();
    },
    toggleFreeGift() {
      if (this.o.free_gift) this.removeFreeGift();
      else this.addFreeGift();
    },
    removeOtherFreeGift() {
      var name = this.freeGiftItem.name;
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-gift fa-sm'></i>&nbsp;Add Free Gift</p>
        <p style='margin-bottom:10px'>Your shop can set 1 Free Gift.</p>
        <p>Your shop already has a Free Gift:</p>
        <p><b>${name}</b></p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Remove Other Free Gift",
      }).then((val) => {
        if (val.value) this.$emit("removeOtherFreeGift");
      });
    },
    addFreeGift() {
      if (this.freeGiftItem) return this.removeOtherFreeGift();
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-gift fa-sm'></i>&nbsp;Add Free Gift</p>
        <p style='margin-bottom:10px'>Your shop can set 1 Free Gift.</p>
        <p>If you set this item as the Free Gift customers can add it to their order if they purchase over the amount you enter below.</p>
        </div>`,
        input: "number",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Add Free Gift",
        inputValidator: (val) => {
          if (!val || val == "0" || parseInt(val) < 0)
            return "Enter an amount > 0";
        },
      }).then((val) => {
        if (val.value) {
          this.o.free_gift = parseInt(val.value);
          this.o.price = "0"; // prices are stored as strings...
          this.o.special = false;
          this.o.flash_deal = false;
          this.clearDiscount(); // set discount to 0
          this.update();
          var msg = `Free Gift over ${this.o.free_gift}`;
          this.notifySuperusersAboutPromo(msg);
        }
      });
    },
    removeFreeGift() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-gift fa-sm'></i>&nbsp;Remove Free Gift</p>
        <p>Your shop can set 1 Free Gift.</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Remove Free Gift",
      }).then((val) => {
        if (val.value) {
          this.o.out_of_stock = true;
          this.o.free_gift = null;
          this.update();
          this.stopEditItem();
          // this.notifySuperusersAboutFlashDeal(o);
        }
      });
    },
    notifySuperusersAboutPromo(promoType) {
      this.sendEmail(promoType);
    },
    notifySuperusersAboutFlashDeal() {
      this.sendEmail("Flash Deal");
      // var flashDeal = `FLASH DEAL @ ${this.business.name}: ${this.o.name}`;
      // this.sendSuperuserNotification(flashDeal);
    },
    sendEmail(type) {
      var obj = {
        type: type,
        shop_name: this.business.name,
        deal: this.o.name,
        user_id: this.$store.state.user.id,
        uuid: this.$store.getters.getUUID,
        mobile: this.$store.getters.phoneNumber,
        name: this.$store.getters.realName,
        app: process.env.VUE_APP_TITLE,
      };
      this.$store.dispatch("sendEmail", obj).catch((err) => console.error(err));
    },
    newOptionsMenu() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-ellipsis-h'></i>&nbsp;Create Options</p>
        <p style='margin-bottom:10px'>Are the options relevant only to this item?</p>
        <p>Choose <b>Multiple items</b> if you want to re-use these options on other items.</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonColor: this.bulmaColor("info"),
        confirmButtonText:
          "<i class='fa fa-clone'></i>&nbsp;Use on multiple items",
        cancelButtonText:
          "<i class='fa fa-square'></i>&nbsp;Only use on this item",
      }).then((val) => {
        if (val.dismiss === "close" || val.dismiss === "backdrop") return;
        if (val.dismiss === "cancel")
          this.$emit("newOptionsMenu", this.selectedItem.id);
        else this.$emit("newOptionsMenu");
        this.close();
      });
    },
    updateOptionsMenu(m) {
      this.editingOptionsMenu = m;
    },
    defaultImg(e) {
      e.target.src = this.$store.state.menuItemPlaceholderPic;
    },
    optionsName(o) {
      return o[this.contentLang] || o.name;
    },
    optionsList(options) {
      // var arr = this.optionsMenus.filter((m) => options.includes(m.id)); // << not correct order
      var arr = [];
      options.forEach((o) => {
        var m = this.optionsMenus.find((m) => o === m.id);
        if (m) arr.push(m);
      });
      var obsolete = "";
      if (options.length !== arr.length) obsolete = "!!! ";
      return obsolete + arr.map((a) => this.optionsName(a.data)).join(", ");
    },
    categoryName(c) {
      var cat = this.categories.find((o) => o.name === c);
      if (!cat) return "!! " + c; // category doesn't exist
      return cat[this.contentLang] || cat.name;
    },
    editCategoryName() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em'><i class='fa fa-cat'></i>&nbsp;Edit Category Name</p>
        </div>`,
        input: "text",
        inputValue: this.editingCategory.name,
        showCloseButton: true,
        inputValidator: (txt) => {
          if (!txt) return "Enter a name";
        },
      }).then((val) => {
        if (val.value) {
          // need to change category name on existing items
          this.updateCategoryOnItems(this.editingCategory.name, val.value);
          this.editingCategory.name = val.value;
          this.saveCategories();
        }
      });
    },
    stopEditCategory() {
      this.editingCategory = null;
      this.saveCategories();
    },
    updateCategoryOnItems(oldName, newName) {
      this.items.forEach((i) => {
        if (i.category === oldName) {
          i.category = newName;
          this.edited = true;
        }
      });
    },
    addNewCategory() {
      this.addingNewCategory = true;
    },
    addDefaultCategory(name) {
      if (this.categories.find((c) => c.name === name)) {
        return this.warningToast("Category exists");
      }
      this.categories.push({ name: name });
      this.saveCategories();
      this.addingNewCategory = false;
    },
    addCustomCategory() {
      this.$emit("addCustomCategory");
    },
    capitalise(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    resetEdit() {
      this.editCategory = false; // close this
      this.editOptions = false;
      this.editTags = false;
      this.editSchedule = false;
      this.editByWeight = false;
    },
    stopEditItem() {
      this.resetEdit();
      this.close();
      //   this.editingItem = null;
    },
    nextItem() {
      //   if (this.edited) this.$emit("save");
      this.$emit("next", this.o);
      this.$nextTick(() => this.setObject());
      var loader = this.loadingDots(this.bulmaColor("info"));
      setTimeout(() => loader.hide(), 100);
      //   var idx = this.items.map((i) => i.id).indexOf(this.editingItem);
      //   var maxIdx = this.items.length - 1;
      //   var nextIdx = idx + 1;
      //   if (nextIdx > maxIdx) nextIdx = 0;
      //   this.stopEditItem();
      //   this.$nextTick(() => this.editItem(this.items[nextIdx].id));
    },
    optionsItemCount(id) {
      return this.items.filter((i) => {
        return i.options && i.options.includes(id);
      }).length;
    },
    catItemCount(catName) {
      return this.items.filter((i) => i.category === catName).length;
    },
    editCategories(c) {
      // editing a master category
      this.editingCategory = c;
      this.addingNewCategory = false; // close green panel if it was open
      this.languages.forEach((l) => {
        if (!this.editingCategory[l]) {
          this.editingCategory[l] = this.editingCategory.name;
        }
      });
    },
    deleteCategory() {
      if (this.catItemCount(this.editingCategory.name)) {
        this.updateCategoryOnItems(this.editingCategory.name, null);
        this.warningToast("Remember to save menu items!");
      }
      var index = this.categories.indexOf(this.editingCategory);
      this.categories.splice(index, 1);
      this.saveCategories();
      this.editingCategory = null;
    },
    setCategory(o, catName) {
      if (o.category === catName) {
        o.category = null;
      } else {
        o.category = catName;
        this.editCategory = false;
      }
      this.edited = true;
    },
    clearSchedule() {
      this.o.schedule = null;
      this.update();
    },
    setSchedule(o, day) {
      if (!o.schedule) o.schedule = [];
      if (o.schedule.includes(day)) {
        o.schedule = o.schedule.filter((d) => d !== day);
      } else {
        o.schedule.push(day);
      }
      if (o.schedule.length === 7) o.schedule = null; // all days
      this.update();
    },
    isScheduleDay(o, d) {
      if (!o.schedule) return false;
      return o.schedule.includes(d);
    },
    setByWeight(o, w) {
      if (o.by_weight === w) o.by_weight = null;
      else o.by_weight = w;
      this.update();
    },
    isByWeight(o, w) {
      if (!o.by_weight) return false;
      return o.by_weight === w;
    },
    setTag(o, tag) {
      if (!o.tags) o.tags = [];
      if (o.tags.includes(tag)) {
        o.tags = o.tags.filter((t) => t !== tag);
      } else {
        o.tags.push(tag);
      }
      if (!this.allTags.includes(tag)) this.newTags.push(tag);
      this.update();
    },
    isTag(o, t) {
      if (!o.tags) return false;
      return o.tags.includes(t);
    },
    setOptions(o, m) {
      if (!o.options) o.options = [];
      if (o.options.includes(m.id)) {
        o.options = o.options.filter((o) => o !== m.id);
      } else {
        o.options.push(m.id);
      }
      this.update();
    },
    isOptions(o, m) {
      if (!o.options) return false;
      return o.options.includes(m.id);
    },
    optionRank(o, m) {
      if (!this.isOptions(o, m)) return null;
      return o.options.findIndex((o) => o === m.id) + 1;
    },
    preToggleOutOfStock() {
      // automatic or manual
    },
    toggleOutOfStock() {
      this.o.out_of_stock = !this.o.out_of_stock;
      this.update();
    },
    toggleSpecial() {
      this.o.special = !this.o.special;
      this.update();
      if (this.o.special) this.infoToast("Added special!");
    },
    toggleVatable() {
      this.o.vatable = !this.o.vatable;
      this.update();
    },
    clearDiscount() {
      this.o.discount = null;
      this.edited = true;
    },
    validateDiscount(o) {
      if (o.discount == 0) {
        this.clearDiscount(o);
        return;
      }
      if (this.isPercentDiscount) {
        if (o.discount < 1 || o.discount > 100) {
          var msg = `Invalid percent discount: ${o.discount} %<br>Enter an integer percent between 1 - 100 %`;
          // alert(msg);
          this.errorToast(msg, "top");
          o.discount = null;
        }
      } else {
        console.log("check number discount", o.discount, o.price);
        if (parseInt(o.discount) > parseInt(o.price)) {
          msg = `Number discount greater than item price<br>${o.discount} > ${o.price}`;
          this.warningToast(msg, "top");
          o.discount = o.price;
        }
      }
      o.discount = Math.trunc(o.discount);
      this.edited = true;
    },
  },
};
</script>

<style scoped>
.advanced-menu-editor-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(128, 128, 128, 0.5);
  z-index: 21;
  backdrop-filter: blur(1px);
}

.background {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.wrapper {
  position: absolute;
  bottom: 0;
  right: 0;
  max-width: 500px;
  height: 100vh;
  overflow: scroll;
  width: 100vw;
  overflow-x: hidden;
  padding: 12px;
  padding-bottom: 90px;
  background-color: rgba(255, 255, 255, 1);
  text-align: left;
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
  box-shadow: 0 0 3px #444;
}

.menu-item {
  border: 1px solid #ddd;
  border-radius: 4px;
}

.menu-pic {
  flex-shrink: 1;
  height: 108px;
  position: relative;
}

.contain-img {
  object-fit: contain !important;
}

.is-flex img {
  object-fit: cover;
  height: 110px;
  width: 110px;
  border-radius: 2px;
  margin: -1px;
  margin-right: 8px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

.no-img {
  /* margin-left: 1px; */
  border-radius: 2px;
  object-fit: cover;
  height: 110px;
  width: 110px;
  margin: -1px;
  margin-right: 8px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
}

.advanced {
  z-index: 0;
  margin-top: 10px;
  /* border-top: 1px solid rgba(230, 230, 230, 0.5); */
  max-width: 100%;
  overflow: hidden;
}

.discount {
  text-decoration: line-through;
  color: #777;
}

.categories span {
  margin-right: 6px;
}

.button.is-small.is-rounded {
  padding: 0 6px;
}

.single-line {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
}

.availability .button {
  margin-right: 8px;
  font-weight: 500;
  /* color: black; */
  /* box-shadow: 1px 1px 1px rgba(128, 128, 128, 0.7); */
}

.fa-external-link-alt {
  padding-right: 15px;
  margin-top: -2px;
}

.buttons {
  margin-bottom: 4px;
}

.wleft .button {
  width: 110px;
  border: 1px solid #ddd;
}

.click-set {
  /* background-color: rgb(255, 255, 149); */
  background-color: whitesmoke;
  color: #999;
  padding: 0 6px;
  border-radius: 20px;
  box-shadow: 1px 1px 2px #ccc;
  /* border: 1px solid #bbb; */
}

.choose-category {
  padding: 4px;
  border: 1px solid #eee;
  border-radius: 5px;
  background-color: white;
  margin-bottom: 10px;
}

.new-category {
  background-color: white;
  /* background-color: rgb(227, 227, 227); */
  padding: 10px;
  margin-top: 0px;
  /* border-radius: 5px; */
  box-shadow: 0 0 2px grey;
}

.special {
  position: absolute;
  /* left: 2px; */
  padding: 2px;
  margin: -1px;
  /* z-index: 0; */
  background-color: rgba(255, 217, 0, 0.8);
  border-radius: 2px;
}

.counter {
  background-color: #eee;
  border-radius: 20px;
  padding: 0 8px;
  margin-right: -10px;
}

.counter-btn {
  padding-left: 9px;
  padding-right: 3px;
}

.bg-pink {
  background-color: rgb(255, 207, 215);
}

.bg-hidden {
  background-color: rgb(212, 212, 212);
}

.bg-yellow {
  background-color: rgb(255, 217, 0);
}

.mr-4 {
  margin-right: 8px;
}

.wleft .fa,
.wleft .far {
  color: grey;
}

.fa-chevron-left {
  margin-right: 6px;
}

.cat-tag {
  background-color: #eee;
  border-radius: 3px;
  padding: 0 2px;
  line-height: 0.8em;
  font-size: 0.85em;
}

.name-description {
  min-height: 70px;
}

.item-name {
  flex: 1;
  font-weight: 450;
  /* min-height: 70px; */
  margin-top: 6px;
  overflow: hidden;
}

.item-description {
  color: #555;
  font-size: 0.9em;
}

/* .bottom-btns {
  margin-top: 20px;
  padding-top: 8px;
} */
.bottom-btns {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px 12px;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(2px);
}

/* .bottom-btns .button {
  box-shadow: 0 0 4px white;
} */
.is-pulled-left .tag {
  font-size: 1em;
}

.special-btn {
  border: 1px dashed #ddd;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 1em;
}

.selected-btn {
  border: 2px solid var(--info);
  background-color: var(--warning);
  color: black;
}

.hint {
  margin: 6px;
  font-weight: 450;
  font-size: 0.9em;
  color: #aaa;
}

.border-yellow {
  box-shadow: inset 0 0 0 5px var(--warning);
}

.option-rank {
  margin-left: 6px;
  margin-right: -6px;
  border-radius: 10px;
  background-color: #ddd;
  color: black;
  font-size: 0.8em;
  padding: 0 6px;
  font-weight: 500;
}
</style>